/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { ID } from '@gh/common-shared-data';

export type ReportFilterFieldDto = {
  name: string;
  value: any;
  id?: boolean;
};

export type ReportFilterDto = ReportFilterFieldDto[];
export type PrintFilterDto = {
  supervisorId: ID;
  supervisorChoise: string;
  format: string;
  onlyActiveJobs: boolean;
  onlyNotCompletedTasks: boolean;
  showCompletedTasks: boolean;
};

export type JasperReport = {
  linkToReport: string;
};

export type JasperPrint = {
  webViewLink: string;
};

export const getReportLink = ({ linkToReport }: JasperReport): string => linkToReport;
export const getPrintLink = ({ webViewLink }: JasperPrint): string => webViewLink;

export const reportField = (name: string, value: any, id?: boolean) => ({ name, value, id });
export const reportIdField = (name: string, id: ID) => ({ name, value: id, id: true });
